module.exports = __webpack_public_path__ + "static/img/function01.3f017c92.png";